import { trackEvent } from "../analytics";
import { ANALYTICS } from "./analyticsEvents";
import { parseBriefingPushParams } from "./pushDeepLinks";

const BRIEFING_PUSH_TAP_DEDUP_KEY = "albis.lastBriefingPushTap";

function shouldSkipDuplicateTap(params) {
  const key = `${params.kind}:${params.briefing_date}:${params.signals || ""}`;
  try {
    const last = sessionStorage.getItem(BRIEFING_PUSH_TAP_DEDUP_KEY);
    if (last === key) return true;
    sessionStorage.setItem(BRIEFING_PUSH_TAP_DEDUP_KEY, key);
  } catch {
    /* ignore */
  }
  return false;
}

/**
 * @param {{
 *   analytics?: { event?: string, kind?: string, briefing_date?: string, signals?: string[] } | null,
 *   searchParams?: URLSearchParams,
 * }} args
 */
export function trackBriefingPushTap({ analytics, searchParams } = {}) {
  let params = null;
  let source = "push";

  if (analytics?.event === ANALYTICS.briefing_push_tap) {
    params = {
      kind: analytics.kind || null,
      briefing_date: analytics.briefing_date || null,
      signals: Array.isArray(analytics.signals) ? analytics.signals : [],
      source: "push",
    };
  } else if (searchParams) {
    const parsed = parseBriefingPushParams(searchParams);
    if (!parsed) return;
    params = {
      kind: parsed.kind,
      briefing_date: parsed.briefingDate,
      signals: parsed.signals,
      source: "deep_link",
    };
    source = params.source;
  }

  if (!params) return;
  if (shouldSkipDuplicateTap(params)) return;

  trackEvent(ANALYTICS.briefing_push_tap, {
    kind: params.kind,
    briefing_date: params.briefing_date,
    signals: params.signals.length ? params.signals.join(",") : null,
    source,
  });
}
